import {
    STORE_CUSTOMER_LOAN,
    STORE_BORROWERS,
    STORE_BORROWER,
    REMOVE_BORROWER,
} from '../../constants/loan';

const initialState = {
    customerLoanHistory: {},
    borrowers: [],
    totalOutstanding: 0,
    activeLoans: 0,
};

const upsertBorrower = (borrowers, borrower) => {
    const idx = borrowers.findIndex(
        (b) => b.borrowerId === borrower.borrowerId || b.id === borrower.id,
    );
    if (idx === -1) return [borrower, ...borrowers];
    const next = borrowers.slice();
    next[idx] = borrower;
    return next;
};

const recomputeTotals = (borrowers) => {
    let totalOutstanding = 0;
    let activeLoans = 0;
    borrowers.forEach((b) => {
        const balance = Number(b.balance) || 0;
        if (balance > 0) {
            totalOutstanding += balance;
            activeLoans += 1;
        }
    });
    return { totalOutstanding, activeLoans };
};

export default (state = initialState, action) => {
    switch (action.type) {
        case STORE_CUSTOMER_LOAN:
            return {
                ...state,
                customerLoanHistory: action.loanHistory,
            };

        case STORE_BORROWERS: {
            const borrowers = action.payload?.borrowers || [];
            return {
                ...state,
                borrowers,
                totalOutstanding:
                    action.payload?.totalOutstanding ??
                    recomputeTotals(borrowers).totalOutstanding,
                activeLoans:
                    action.payload?.activeLoans ??
                    recomputeTotals(borrowers).activeLoans,
            };
        }

        case STORE_BORROWER: {
            const borrowers = upsertBorrower(state.borrowers, action.borrower);
            return { ...state, borrowers, ...recomputeTotals(borrowers) };
        }

        case REMOVE_BORROWER: {
            const borrowers = state.borrowers.filter(
                (b) =>
                    b.borrowerId !== action.borrowerId &&
                    b.id !== action.borrowerId,
            );
            return { ...state, borrowers, ...recomputeTotals(borrowers) };
        }

        default:
            return state;
    }
};
